import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import { getWaitScreeningDepartment6 } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitScreeningInitial({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard()
    }
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getWaitScreeningDepartment6(5, 1)
      // console.log('getWaitScreening => ', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const handleGetWaitScrutinize = async (pagesize, pagenumber) => {
    // startLoading()
    setIsLoading(true)
    try {
      const response = await getWaitScreeningDepartment6(pagesize, pagenumber)
      // console.log('response getWaitScrutinize', response)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
    // doneLoading()
  }

  const onMultiSubmit = (selectList) => {
    console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')

    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            resizeProjectTypeField={true}
            subName={{ enable: true }}
            multi={{ enable: false, buttonText: 'ไปยังการคัดกรอง' }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handleGetWaitScrutinize}
            loading={isLoading}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รอกลั่นกรองเชิงประเด็น(สำนัก6)',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectReviewTypeText: 'วิธีการกลั่นกรอง',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'กลั่นกรอง',
  mutiButtonText: 'ไปยังการกลั่นกรองหลายโครงการ',
  singleIcon: 'filter',
  totalSize: 1,
  values: [
    {
      id: '',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXXXX',
        statusName: 'สถานะ XXX',
      },
      projectBudget: '9,999,999.99',
      projectType: { value: 'โครงการ', label: '1' },
      projectReviewType: '1',
      projectReviewTypeLabel: 'เสนอกลั่นกรอง',
      multiDisabled: true,
    },
  ],
}
